import styled from "styled-components"

export const TabsWrapper = styled.div`
    display: grid;
    grid-auto-columns: minmax(0, 1fr);
    grid-auto-flow: column;
`

export const Tab = styled.div`
    text-align: center;
    border: 1px solid #dbeafe;
    padding: 1rem;
    background-color: ${props => props.active==='true' && '#2563eb'};
    color: ${props => props.active==='true' && 'white'};
    cursor: pointer;

    &:hover {
        background-color: ${props => !props.active && '#dbeafe;'};
    }
`